/** common methods for profile info **/
export default {
  methods: {
    dateOfBirth(patient) {
      if (patient.dateOfBirthYear) {
        if (patient.dateOfBirthMonth) {
          return `${patient.dateOfBirthMonth}/${patient.dateOfBirthDay}/${patient.dateOfBirthYear}`;
        } else {
          // entire date cannot be displayed
          return 'xx-xx-' + patient.dateOfBirthYear;
        }
      }
      if (patient.age && patient.age > 12) {
        return 'Age: ' + patient.age;
      }
      return '--';
    }
  }
};
